import apiFactory from './api-factory'
import { dehydrate as progressDehydrate } from './progress'

const category = {
  ...apiFactory('/api/polls/category/', ['getList', 'getDetail'], {
    dehydrate,
  }),

  getListForPoll(poll, params, context) {
    return this.getList({ ...params, poll }, context)
  },

  getListForParentPoll(poll, params, context) {
    return this.getList({ ...params, parent_poll: poll }, context)
  },

  getListForParentBranchingQuestion(branchingQuestion, params, context) {
    return this.getList(
      {
        ...params,
        parent_branching_question: branchingQuestion,
      },
      context
    )
  },
}

export function dehydrate({ pk, name, tooltip, progress }) {
  return {
    type: 'categories',
    pk,
    name,
    tooltip,
    progress: progress ? progressDehydrate(progress) : null,
  }
}

export default category
